import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GuardWithAttendance } from '../../pages/attendance/view/AttendancePage';
import { SalaryDistributionSummary } from '../../pages/attendance/service/paymentService';

interface AttendanceState {
  guards: GuardWithAttendance[];
  salaryDistribution: SalaryDistributionSummary | null;
  lastFetched: number | null;
  companyId: string | null;
  salarySummarySelectedYear: number | null;
  salarySummarySelectedMonth: number | null;
}

const initialState: AttendanceState = {
  guards: [],
  salaryDistribution: null,
  lastFetched: null,
  companyId: null,
  salarySummarySelectedYear: null,
  salarySummarySelectedMonth: null,
};

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    setGuards: (state, action: PayloadAction<{ guards: GuardWithAttendance[]; companyId: string }>) => {
      console.log('Redux setGuards action called with:', action.payload.guards.length, 'guards');
      state.guards = action.payload.guards;
      state.companyId = action.payload.companyId;
      state.lastFetched = Date.now();
      console.log('Redux state updated - guards:', state.guards.length, 'companyId:', state.companyId);
    },
    updateGuard: (state, action: PayloadAction<GuardWithAttendance>) => {
      const index = state.guards.findIndex(g => g.id === action.payload.id);
      if (index !== -1) {
        state.guards[index] = action.payload;
      }
    },
    setSalaryDistribution: (state, action: PayloadAction<SalaryDistributionSummary>) => {
      state.salaryDistribution = action.payload;
    },
    clearSalaryDistribution: (state) => {
      state.salaryDistribution = null;
    },
    setSalarySummarySelection: (state, action: PayloadAction<{ year: number; month: number }>) => {
      state.salarySummarySelectedYear = action.payload.year;
      state.salarySummarySelectedMonth = action.payload.month;
    },
    clearAttendance: (state) => {
      state.guards = [];
      state.salaryDistribution = null;
      state.lastFetched = null;
      state.companyId = null;
      state.salarySummarySelectedYear = null;
      state.salarySummarySelectedMonth = null;
    },
  },
});

export const { setGuards, updateGuard, setSalaryDistribution, clearSalaryDistribution, setSalarySummarySelection, clearAttendance } = attendanceSlice.actions;
export default attendanceSlice.reducer;

